// extracted by mini-css-extract-plugin
export default {"zoomControls":"Sca-z","zoomControlButton":"Tca-z","zoomBanner":"Uca-z","bannerButton":"Vca-z","imageButton":"Wca-z","zoom":"Xca-z","zoomContent":"Yca-z"};